/**
 * Where the API lives. Its own module so the session code can reach the API
 * without importing apiClient, which itself depends on the session code.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1';
